
































import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import { ProductCategory } from '@/model/productCategory'
import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES } from '@/common/constants'

export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    categories: {
      type: Array as () => ProductCategory[],
      default: () => []
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    displayedCategories(): ProductCategory[] {
      return this.categories.filter(category => category.childCategories.length)
    },
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    }
  }
})
